import React from "react";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";

import { useLayoutStore } from "@store/layout";

export default function Modal() {
  const { modal, openModal, isLoading } = useLayoutStore();

  const hasCTA = Boolean(modal?.cancel) || Boolean(modal?.confirm);

  return (
    <div className="relative dark:text-white">
      <section className="center pc:w-1/3 fixed z-80 flex max-h-[80%] w-[calc((100%-2rem))] flex-col rounded-sm bg-white px-5 pt-5 shadow lg:w-1/4 dark:bg-black dark:shadow-white">
        <div className="mb-5 flex flex-row justify-between">
          <span className="uppercase">{modal?.title || ""}</span>
          <Button
            as="text"
            onClick={() => {
              modal?.onClickClose?.();
              openModal(null);
            }}
          >
            Close
          </Button>
        </div>
        <div className="scrollbar-hide overflow-y-scroll pb-5">{modal?.content || ""}</div>

        {hasCTA ? (
          <div className="flex flex-row gap-1 pb-5">
            {Boolean(modal?.cancel) && (
              <Button
                as="square"
                onClick={() => {
                  openModal(null);
                  modal?.cancel?.onClick?.();
                }}
                variant={modal?.confirm ? "secondary" : "primary"}
              >
                {modal?.cancel?.label}
              </Button>
            )}
            {Boolean(modal?.confirm) && (
              <Button
                as="square"
                loading={isLoading}
                onClick={() => {
                  modal?.confirm?.onClick?.();
                }}
              >
                {modal?.confirm?.label}
              </Button>
            )}
          </div>
        ) : (
          <>
            {!modal?.isHideCancelButton ? (
              <Button
                as="square"
                onClick={() => {
                  openModal(null);
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            ) : null}
          </>
        )}
      </section>

      <Dim
        onClick={(e) => {
          e.stopPropagation();
          // modal?.cancel?.onClick?.();
          modal?.onClickClose?.();
          openModal(null);
        }}
      />
    </div>
  );
}
